import styled from 'styled-components'
import { FiArrowLeft } from 'react-icons/fi'
import i18n from '../../../i18n'

const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.lg};
  padding: ${props => props.theme.spacing.lg} 1.5rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    padding: ${props => props.theme.spacing.md} 1rem;
  }
`

const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sm};
  min-width: 0;
`

const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${props => props.theme.controlHeight};
  height: ${props => props.theme.controlHeight};
  border: none;
  border-radius: ${props => props.theme.radius.button};
  background: transparent;
  color: ${props => props.theme.colors.text.secondary};
  cursor: pointer;
  transition: ${props => props.theme.transitions.default};

  &:hover {
    background: ${props => props.theme.colors.background.hover};
    color: ${props => props.theme.colors.text.primary};
  }

  svg {
    font-size: 1.1rem;
  }
`

const Title = styled.h1`
  font-size: ${props => props.theme.typography.fontSize.title};
  font-weight: 600;
  font-family: ${props => props.theme.typography.fontFamily};
  color: ${props => props.theme.colors.text.primary};
  letter-spacing: -0.01em;
  margin: 0;
`

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sm};
  flex-wrap: wrap;
`

export default function PageHeader ({ title, children, backTo, onBack, navigate }) {
  const handleBack = onBack || (backTo && navigate ? () => navigate(backTo) : null)

  return (
    <Header>
      <TitleGroup>
        {handleBack && (
          <BackButton type='button' onClick={handleBack} aria-label={i18n.t('back', { ns: 'common', defaultValue: 'Indietro' })}>
            <FiArrowLeft />
          </BackButton>
        )}
        <Title>{title}</Title>
      </TitleGroup>
      <Actions>{children}</Actions>
    </Header>
  )
}
